import Sheet from './Sheet';
import SheetBackdrop from './SheetBackdrop';
import SheetCloseIndicator from './SheetCloseIndicator';
import SheetContainer from './SheetContainer';
import SheetContent from './SheetContent';
import SheetHeader from './SheetHeader';

export type SheetRef = {
  snapTo: (index: number) => void;
};

type SheetCompoundComponent = {
  Container: typeof SheetContainer;
  Header: typeof SheetHeader;
  Content: typeof SheetContent;
  Backdrop: typeof SheetBackdrop;
  CloseIndicator: typeof SheetCloseIndicator;
};

// HACK: this is needed to get the typing to work properly...
const _Sheet: any = Sheet;
_Sheet.Container = SheetContainer;
_Sheet.Header = SheetHeader;
_Sheet.Content = SheetContent;
_Sheet.Backdrop = SheetBackdrop;
_Sheet.CloseIndicator = SheetCloseIndicator;

const SheetCompound: typeof Sheet & SheetCompoundComponent = _Sheet;

export default SheetCompound;
